import React from 'react';
import PropTypes from 'prop-types';
import './TableSkeletonLoader.css';

const TableSkeletonLoader = ({rows = 5, rowHeight = 40, spacing = 12}) => {
  return (
    <div className='table-skeleton-wrapper'>
      {new Array(rows).fill().map(() => (
        <div
          key={crypto.randomUUID()}
          data-testid='table-skeleton-line'
          className='table-skeleton-line'
          style={{
            height: `${rowHeight}px`,
            marginBottom: `${spacing}px`
          }}
        />
      ))}
    </div>
  );
};

TableSkeletonLoader.propTypes = {
  rows: PropTypes.number,
  rowHeight: PropTypes.number,
  spacing: PropTypes.number
};

export default React.memo(TableSkeletonLoader);
